module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "losangeles_banner.26c79e9c.png";